import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import JavaScriptMedia from './JavaScriptMedia';
import ClientProvider from './client';
export default createDemo(import.meta.url, JavaScriptMedia, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/use-media-query/demos/java-script-media/JavaScriptMedia.tsx",
    "fileName": "JavaScriptMedia.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import json2mq from 'json2mq';\nimport useMediaQuery from '@mui/material/useMediaQuery';\n\nexport default function JavaScriptMedia() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 0,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const matches = useMediaQuery(\n    json2mq({\n      minWidth: 600,\n    }),\n  );\n\n  return <span>{`{ minWidth: 600 } matches: ${matches}`}</span>;\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 12,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import json2mq from 'json2mq';\nimport useMediaQuery from '@mui/material/useMediaQuery';\n\nexport default function JavaScriptMedia() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        "  const matches = useMediaQuery(\n    json2mq({\n      minWidth: 600,\n    }),\n  );\n\n  return <span>{`{ minWidth: 600 } matches: ${matches}`}</span>;\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "const"
              ],
              " ",
              [
                "span",
                "pl-c1",
                "matches"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              " ",
              [
                "span",
                "pl-en",
                "useMediaQuery"
              ],
              "("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "    ",
              [
                "span",
                "pl-en",
                "json2mq"
              ],
              "({"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      ",
              [
                "span",
                "di-op",
                "minWidth"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "600"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            "    }),"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            "  );"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            "\n"
          ],
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "return"
              ],
              " <",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  "{ minWidth: 600 } matches: ",
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "matches"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">;"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 12,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "json2mq",
      "@mui/material/useMediaQuery"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
